/**
 * RetirementSetupPrompt Component
 * WP-RETIRE-2: First-time user CTA with setup button
 */

import Button from '@/components/ui/Button';

interface RetirementSetupPromptProps {
  onSetup: () => void;
  isLoading?: boolean;
}

export default function RetirementSetupPrompt({
  onSetup,
  isLoading = false,
}: RetirementSetupPromptProps) {
  return (
    <div className="flex flex-col items-center justify-center py-8 text-center">
      <div className="text-4xl mb-4" aria-hidden="true">
        <svg
          className="w-16 h-16 text-gray-400 mx-auto"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        Plan for your financial future
      </h3>
      <p className="text-sm text-gray-600 mb-6 max-w-md">
        See projections of your retirement readiness based on your current savings, expected
        income, and expenses.
      </p>
      <Button onClick={onSetup} isLoading={isLoading} disabled={isLoading}>
        Set Up Retirement Planning
      </Button>
    </div>
  );
}
